import React from "react";
import { connect } from "react-redux";
import { Div, Span } from "components/Base";
import { actions, getters } from "Portal/CallForPapersForm/model";

const decorate = connect(
  state => ({
    loggedInLabel: getters.loggedInLabel(state),
    isLoggedIn: getters.isLoggedIn(state)
  }),
  {
    handleLogout: actions.handleLogout
  }
);

const LoggedInAs = ({ isLoggedIn, loggedInLabel, handleLogout }) => {
  return !isLoggedIn ? null : (
    <Div textAlign="center" mt={7} pb={5} width={1}>
      You are logged in as {loggedInLabel}. Not you?{" "}
      <Span
        tabIndex={0}
        onClick={handleLogout}
        underline
        aria-role="button"
        aria-label="Click here to log out"
      >
        Click here to log out.
      </Span>
    </Div>
  );
};

export default decorate(LoggedInAs);
